import { FileTypes } from "../models";

const { mp4, webm } = FileTypes;
export const videoTypes = [mp4, webm];

export const isVideo = (type: string): boolean => videoTypes.includes(type as FileTypes);
